import device from './device';

export default function allowFlash() {
    return device.isFlashCapable();
}



// WEBPACK FOOTER //
// ./src/js/util/allow-flash.js